import React from 'react';
import {Table} from 'reactstrap';
import ProgramRow from './ProgramRow';

const ProgramsWidget = ({node, onStart, onStop, values}) => (
    <>
        <h4>Programs</h4>
        <Table size="sm">
            <tbody>
                {node.properties.map((p) => (
                    <ProgramRow key={p.id}
                        node={node} property={p} isRunning={values[`${node.id}/${p.id}`]}
                        onStart={onStart} onStop={onStop} />
                ))}
            </tbody>
        </Table>
    </>
);

export default ProgramsWidget;
